module.exports = __webpack_public_path__ + "vrplayerstatic/media/fullScreenOn.79168adb.svg";